import LAYOUT from '@/layouts/default/index.vue';

export default {
  path: '/makeUp',
  component: LAYOUT,
  name: 'MakeUp',
  redirect: '/makeUp/detail',
  meta: {
    title: '预约下定',
  },
  children: [
    {
      path: 'detail',
      name: 'MakeUpDetail',
      meta: {
        title: '预约下定',
      },
      component: () => import('@/views/makeUp/detail'),
    },
  ],
};
